'use strict';

angular.module('shiftTraderApp')
  .factory('Users', function (ServerUrls, $http, Session, $injector, AvailabilityService,
                              StatisticsService, AvailabilitySets, AvailabilityRules, $q) {
    var path = ServerUrls.current.railsApi + 'users/';
    var nodePath = ServerUrls.current.nodeApi.slice(0, -3) + 'v2/users/';

    //User Model
    var User = function(initData) {
      var usr = {};
      angular.extend(usr, initData);

      if (_.hasOwnProperty(usr, 'sign_in_count')) {
        usr.sign_in_count = parseInt(usr.sign_in_count, 10);
      }

      if (_.hasOwnProperty(usr, 'wizard_completed')) {
        usr.wizard_completed = parseInt(usr.wizard_completed, 10);
      }

      if (usr.birthday) {
        usr.age = moment().diff(moment(usr.birthday, 'YYYY-MM-DD'), 'years')
      }

      var PhoneResource = $injector.get('PhoneResource')
      var UsersPositions = $injector.get('UsersPositions')
      var AR = $injector.get('AvailabilityRules')
      var AS = $injector.get('AvailabilitySets')

      //create PhoneResource's for each phone_number record
      usr.phone_numbers = lodash.map(usr.phone_numbers, function(pn) {
        return new PhoneResource(pn)
      }, this)

      usr.users_positions = lodash.map(usr.users_positions, function(up) {
        return UsersPositions.initWithData(up)
      })

      usr.time_off_rules = lodash.map(usr.time_off_rules, function(rule) {
        return AR.initWithData(rule);
      }, this);

      usr.availability_sets = lodash.map(usr.availability_sets, function(avail_set) {
        return AS.initWithData(avail_set);
      }, this);

      usr.$effectiveAvailabilitySet = function(dt) {
        return lodash.find(usr.availability_sets, function(availSet) {
          return availSet.$isInEffect(dt) && availSet.active && availSet.$isApproved();
        });
      };


      usr.$overlapsWithAvailability = function(wp_twix) {
        return AvailabilityService.processAvailabilityForUser(this, wp_twix);
      };

      usr.$primary_phone_number = function() {
        if (_.isUndefined(this.phone_numbers) || _.isEmpty(this.phone_numbers)) {
          return false;
        } else {
          return _.filter(this.phone_numbers, { 'primary': true })[0].number;
        }
      };


      usr.$primary_formatted_phone_number = function() {
        if (_.isUndefined(this.phone_numbers) || _.isEmpty(this.phone_numbers)) {
          return false;
        } else {
          return _.filter(this.phone_numbers, { 'primary': true })[0].formattedNumber();
        }
      };

      usr.$positionsList = function() {
        if (_.isEmpty(this.users_positions)) {
          return null;
        } else {
          return _.map(this.users_positions, function(up){
            return up.position.name;
          }).join(', ');
        }
      };

      //don't use this right now... causes really bad loops
      usr.$isMe = function() {
        return Session.getCurrentUserId() === this.id;
      };

      usr.$curMemb = function() {
        if (_.has(this, 'memberships') && this.memberships.length > 0) {
          return this.memberships[0];
        } else {
          return {};
        }
      };

      usr.$isAdmin = function() {
        return (_.has(this.$curMemb(), 'role') && this.$curMemb().role === 'admin');
      };

      usr.$isManager = function() {
        return (_.has(this.$curMemb(), 'role') && (this.$curMemb().role === 'manager' || this.$isAdmin() ) );
      };

      usr.$isEmployee = function() {
        return (_.has(this.$curMemb(), 'role') && this.$curMemb().role === 'employee');
      };

      usr.$isNotEmployee = function() {
        return !usr.$isEmployee();
      };

      usr.$update = function(data) {
        var that = this;
        return $http.put(path + this.id, data)
          .then(function(response) {
            //create PhoneResource's for each phone_number record
            usr.phone_numbers = _.map(response.data.phone_numbers, function(pn) {
              return new PhoneResource(pn);
            }, this);

            usr.time_off_rules = _.map(response.data.time_off_rules, function(rule) {
              return AR.initWithData(rule);
            }, this);

            delete response.data.time_off_rules;
            delete response.data.phone_numbers;
            angular.extend(that, response.data);  //copy in new properties from server
            return new User(that);
          }, function(response) {
            return $q.reject(response);
          });
      };

      usr.$finishTour = function (tourName) {
        var that = this
        return $http.put(path + this.id + '/complete_tour', { tour_name: tourName })
          .then(function (response) {
            usr.phone_numbers = _.map(response.data.phone_numbers, function(pn) {
              return new PhoneResource(pn);
            }, this);

            usr.time_off_rules = _.map(response.data.time_off_rules, function(rule) {
              return AR.initWithData(rule);
            }, this);

            delete response.data.time_off_rules;
            delete response.data.phone_numbers;
            angular.extend(that, response.data);
          }, function (response) {
            return $q.reject(response)
          })
      }

      usr.$delete = function(data) {
        // IE8 doesn't like $http.delete name
        return $http['delete'](path + this.id, data)
          .then(function(response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      usr.$addPhoneNumber = function(data) {
        return $http.post(path + this.id + '/phone_numbers/', data)
          .then(function(response) {
            usr.phone_numbers.push(new PhoneResource(response.data))
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      usr.$removePhoneNumber = function(pn_id) {
        // IE8 doesn't like $http.delete name
        return $http['delete'](path + this.id + '/phone_numbers/' + pn_id)
          .then(function(response){
            return response.data.status;
          }, function(response) {
            return $q.reject(response);
          });
      };

      usr.$setPrimaryPhoneNumber = function(pn_id) {
        var data = {primary: true, id: pn_id};
        return $http.put(path + this.id + '/phone_numbers/' + pn_id, data)
          .then(function(response){
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      usr.$isAllowedToTrade = function() {
        return this.memberships[0].user_org_config.allow_trading === true;
      };

      usr.$hasCompletedWizard = function() {
        if (_.hasOwnProperty(this, 'wizard_completed')) {
          return this.wizard_completed;
        }
        else {
          return false;
        }
      };

      usr.$hasPosition = function(positionId) {
        positionId = parseInt(positionId);
        return _.any(this.users_positions, function(up) {
          return up.position_id === positionId;
        });
      };

      usr.$isTrainingInPosition = function(positionId) {
        positionId = parseInt(positionId);
        return _.any(this.users_positions, function(up) {
          return up.position_id === positionId && up.training;
        });
      };

      usr.$resendActivationEmail = function() {
        var data = {
          user_id: usr.id,
          organization_id: usr.memberships[0].organization_id
        };
        return $http.get(path + usr.id + '/resend_activation', data);
      };

      usr.$getStatistic = function(statName, options) {
        return StatisticsService.getUserStatistic(usr.id, statName, options);
      };


      usr.$mergeInAvailability = function(compositeAvailability) {
        _.each(_.where(compositeAvailability.time_off_rules, {user_id: usr.id}), function(rule) {
          if (_.isNull(usr.time_off_rules) || _.isUndefined(usr.time_off_rules)) {
            usr.time_off_rules = [];
          }

          var idx = _.findIndex(usr.time_off_rules, {id: rule.id});

          if (idx > -1) {
            usr.time_off_rules[idx] = rule;
          } else {
            usr.time_off_rules.push(rule);
          }
        });

        _.each(_.where(compositeAvailability.availability_sets, {user_id: usr.id}), function(availSet) {
          if (_.isNull(usr.availability_sets) || _.isUndefined(usr.availability_sets)) {
            usr.availability_sets= [];
          }
          var idx = _.findIndex(usr.availability_sets, {id: availSet.id});

          if (idx > -1) {
            usr.availability_sets[idx] = availSet;
          } else {
            usr.availability_sets.push(availSet);
          }
        });
      };

      usr.$getCompositeAvailability = function(startMoment, endMoment) {
        var data = {
          start_date: startMoment.toISOString()
        };

        if (endMoment) {
          data.end_date = endMoment.toISOString();
        }

        return $http.get(path + usr.id + '/composite_availability', {
          params: data
        })
          .then(function(response) {
            var sets = _.map(response.data.availability_sets, function(availSet) {
              return AvailabilitySets.initWithData(availSet);
            });

            var rules = _.map(response.data.time_off_rules, function(rule) {
              return AvailabilityRules.initWithData(rule);
            });

            usr.$mergeInAvailability({
              availability_sets: sets,
              time_off_rules: rules
            });
            return usr;

          }, function(response) {
            console.log('could not load composite availability');
            return $q.reject(response);
          });
      };

      return usr;
    };

    var Users = {};

    Users.create = function(data) {
      return $http.post(ServerUrls.current.railsApi + 'registrations/user', data)
        .then(function(response) {
          return Users.initWithData(response.data);
        }, function(response) {
          return $q.reject(response);
        })
    };

    Users.whoAmI = function () {
      return $http.get(nodePath + 'me')
        .then(function (response) {
          var user = new User(response.data);
          Session.setMe(user);
          Session.setCurrentOrgId(user.memberships[0].organization.id);
          Session.setTimezone(user.memberships[0].organization.organization_config.timezone);
          return user;
        }, function(response) {
          console.log('Users.whoAmI failure', response);
          return $q.reject(response);
        });
    };

    Users.getAll = function (extraParams) {
      var config = {
        params: {
          organization_id:Session.getCurrentOrgId()
        }
      };
      lodash.merge(config.params, extraParams);

      return $http.get(nodePath, config)
        .then(function (response) {
          return _.map(response.data, function(u) {
            return new User(u);
          });
        }, function(response) {
          console.log('Users.getAll failed');
          return $q.reject(response);
        });
    };

    Users.getById = function (id) {
      return $http.get(nodePath + id)
        .then(function (response) {
          return new User(response.data);
        }, function(response) {
          console.log('Users.getById failed');
          return $q.reject(response);
        });
    };

    Users.getByOrgId = function(orgId) {
      return $http.get(path, {organization_id:orgId})
        .then(function(response) {
          return _.map(response.data, function(usr) {
            return new User(usr);
          });
        }, function(response) {
          console.log('Users.getByOrgId failed');
          return $q.reject(response);
        });
    };

    Users.initWithData = function(initData) {
      return new User(initData);
    };

    Users.resendActivationByOrg = function(orgId) {
      return $http.get(path + 'resend_activation', {organization_id: orgId});
    };

    return Users;
  });
